import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { errorInterceptor } from '@core/interceptors/error.interceptor';
import { languageInterceptor } from '@core/interceptors/language.interceptor';
import { environment } from '@env/environment';
import { SSDateAdapter, SSDateParserFormatter } from '@shared/components/date-picker/ss-date-adapter';
import { SSDatepickerI18n } from '@shared/components/date-picker/ss-datepicker-i18n';
import { routes } from './app.routes';
import { LanguageService } from './core/services/language.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(
      withInterceptors([
        //TODO: Remove after stable
        // mockHttpInterceptor,
        languageInterceptor,
        authInterceptor,
        errorInterceptor,
      ]),
    ),
    provideTranslateService({
      fallbackLang: environment.defaultLanguage,
    }),
    provideTranslateHttpLoader({
      prefix: './i18n/',
      suffix: '.json',
    }),
    provideAppInitializer(() => {
      inject(LanguageService);
    }),
    // Config DatePicker
    {
      provide: NgbDateAdapter,
      useClass: SSDateAdapter,
    },
    {
      provide: NgbDateParserFormatter,
      useClass: SSDateParserFormatter,
    },
    {
      provide: NgbDatepickerI18n,
      useClass: SSDatepickerI18n,
    },
  ],
};
